import { useEffect, useState } from 'react';

/**
 * 和 useState 一樣，但值會存在 localStorage，頁面卸載（例如進到行程詳情再返回）或重開 App 後仍保留。
 * 只用於個人顯示偏好；讀寫失敗（無痕模式、儲存空間被封鎖）時退回預設值，不影響功能。
 */
export function useLocalStorageState<T>(key: string, defaultValue: T) {
  const [value, setValue] = useState<T>(() => {
    try {
      const stored = window.localStorage.getItem(key);
      return stored !== null ? (JSON.parse(stored) as T) : defaultValue;
    } catch {
      return defaultValue;
    }
  });

  useEffect(() => {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch {
      // 無法儲存時只是下次回到預設值
    }
  }, [key, value]);

  return [value, setValue] as const;
}
